import { put, takeLatest, select } from "redux-saga/effects";
import {
  login,
  getUserList,
  createUser,
  updateUser,
  getUserInfo,
  getFinancialProfessionalList,
  getClient,
  forgotPassword,
  getAdjustments,
  getPlanCashFlowApi,
  getPlanFutureCashFlowApi,
} from "../shared/api";
import {
  ACTION_SET_BADPASSWORD,
  ACTION_SET_LOGINDATA,
  ACTION_SET_USER_LIST,
  SAGA_LOGIN,
  SAGA_CREATE_USER,
  SAGA_EDIT_USER,
  ACTION_SET_AUTHORIZATION,
  USER_SUPERADMIN,
  USER_FINANCIALPROFESSIONAL,
  ACTION_SET_CURRENTCLIENT,
  ACTION_SET_CURRENTUSER,
  SAGA_FORGOT_PASSWORD,
  ACTION_LOCK_FUTURE_DESTINATION,
  ACTION_SET_PLANINPUT,
  SAGA_GET_PLANINPUT,
  SAGA_RELOAD_USER_LIST,
  SAGA_GET_PLAN_CASH_FLOW,
  SAGA_GET_FUTURE_CASH_FLOW,
  ACTION_SET_CURRENTPLAN_CASHFLOW,
  ACTION_SET_FUTUREPLAN_CASHFLOW,
  ACTION_SET_FORGOT_PASSWORD,
  ACTION_SET_FINANCIAL_PROFESSIONAL
} from "../shared/constants";

function* doLogin(action) {
  const email = action.value.email;
  const password = action.value.password;

  try {
    const userData = yield login(email, password);
    const loggedInUser = yield getUserInfo(userData.accessToken);

    yield put({
      type: ACTION_SET_AUTHORIZATION,
      value: loggedInUser.userRole.name,
    });

    yield put({
      type: ACTION_SET_CURRENTUSER,
      value: `${loggedInUser.firstName} ${loggedInUser.lastName}`,
    });
    yield put({
      type: ACTION_SET_LOGINDATA,
      value: {
        token: userData.accessToken,
        userId: userData.userId,
        userName: userData.userName,
        advisorId: loggedInUser.advisorId,
        firmId: userData.firmId,
      },
    });

    let userList = [];
    if (loggedInUser.userRole.name === USER_SUPERADMIN) {
      userList = yield getUserList(userData.accessToken);
    }

    let fpList = [];
    if (loggedInUser.userRole.name !== USER_FINANCIALPROFESSIONAL) {
      fpList = yield getFinancialProfessionalList(userData.accessToken);
    }

    const usersAndFp = userList.concat(fpList);
    yield put({
      type: ACTION_SET_USER_LIST,
      value: usersAndFp.map((item) => {
        return {
          id: item.advisorId,
          clientId: item.clientId,
          userId: item.userId,
          firstName: item.firstName,
          lastName: item.lastName,
          email: item.email,
          phone: item.phones,
          role: item.role.toUpperCase(),
          createDate: item.createDate,
          firmName: item.firmName,
          isLocked: item.isLocked,
          financialPros: [],
        };
      }),
    });

    if (loggedInUser.userRole.name === USER_FINANCIALPROFESSIONAL) {
      yield put({
        type: ACTION_SET_FINANCIAL_PROFESSIONAL,
        value: loggedInUser
      })
    }

  } catch (err) {
    const message = err.toString() === "User Locked" ? "Your account is locked." : "Wrong email or password."

    yield put({
      type: ACTION_SET_BADPASSWORD,
      value: { message, show: true }
    });
  }
}

function* doCreateUser(action) {
  const authToken = yield select((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );

  yield createUser(
    {
      advisorId: action.value.id,
      clientId: action.value.clientId,
      email: action.value.email,
      firmName: action.value.firmName,
      firstName: action.value.firstName,
      lastName: action.value.lastName,
      phones: action.value.phone,
      role: action.value.role.value,
      fp_ids: action.value.financialPros.map((fpro) => fpro.id),
      status: "A",
      userId: action.value.userId,
    },
    authToken
  );

  // let userList = [];
  const userList = yield getUserList(authToken);

  // let fpList = [];
  const fpList = yield getFinancialProfessionalList(authToken);

  const usersAndFp = userList.concat(fpList);

  yield put({
    type: ACTION_SET_USER_LIST,
    value: usersAndFp.map((item) => {
      return {
        id: item.advisorId,
        clientId: item.clientId,
        userId: item.userId,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        phone: item.phones,
        role: item.role.toUpperCase(),
        createDate: item.createDate,
        firmName: item.firmName,
        isLocked: item.isLocked,
        financialPros: [],
      };
    }),
  });

}

function* doEditUser(action) {
  const authToken = yield select((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );
  yield updateUser(
    {
      advisorId: action.value.id,
      clientId: action.value.clientId,
      email: action.value.email,
      firmName: action.value.firmName,
      firstName: action.value.firstName,
      lastName: action.value.lastName,
      phones: action.value.phone,
      role: action.value.role.value,
      fp_ids: action.value.financialPros.map((fpro) => fpro.id),
      status: "A",
      userId: action.value.userId,
    },
    authToken
  );

  // let userList = [];
  const userList = yield getUserList(authToken);

  // let fpList = [];
  const fpList = yield getFinancialProfessionalList(authToken);

  const usersAndFp = userList.concat(fpList);

  yield put({
    type: ACTION_SET_USER_LIST,
    value: usersAndFp.map((item) => {
      return {
        id: item.advisorId,
        clientId: item.clientId,
        userId: item.userId,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        phone: item.phones,
        role: item.role.toUpperCase(),
        createDate: item.createDate,
        firmName: item.firmName,
        isLocked: item.isLocked,
        financialPros: [],
      };
    }),
  });

}

function* getPlanCashFlow(action) {
  const plan = yield getPlanCashFlowApi(action.value, action.token)
  const client = yield getClient(action.value, action.token);

  yield put({
    type: ACTION_SET_CURRENTPLAN_CASHFLOW,
    value: plan
  })

  yield put({
    type: ACTION_SET_CURRENTCLIENT,
    value: client.data,
  });
}

function* getFuturePlanCashFlow(action) {
  const futurePlan = yield getPlanFutureCashFlowApi(action.value, action.token);
  const futurePlanInput = yield getAdjustments(action.value, action.token);

  yield put({
    type: ACTION_LOCK_FUTURE_DESTINATION,
    value: (futurePlanInput.fiaTransfers.length === 0 && futurePlanInput.insuranceTransfers.length === 0 && futurePlanInput.rothTransfers.length === 0 && futurePlanInput.spendingGoals.length === 0)
  })

  yield put({
    type: ACTION_SET_FUTUREPLAN_CASHFLOW,
    value: futurePlan
  })
}

function* sendEmailForgotPassword(action) {
  try {

    yield forgotPassword(action.value.email)

    yield put({
      type: ACTION_SET_FORGOT_PASSWORD,
      value: `Please, go to ${action.value.email} to get your temporary password.`
    });

  } catch (error) {

    yield put({
      type: ACTION_SET_FORGOT_PASSWORD,
      value: `The user ${action.value.email} is locked, contact with an administrator.`
    });
  }

}

function* getPlanInput(action) {

  yield put({
    type: ACTION_SET_PLANINPUT,
    value: { dataPlanInput: action.value }
  })
}

function* reloadUserList(action) {
  const authToken = yield select((state) =>
    state.dataStore.getIn(["loginInfo", "authorizationToken"])
  );

  // let userList = [];
  const userList = yield getUserList(authToken);

  // let fpList = [];
  const fpList = yield getFinancialProfessionalList(authToken);

  const usersAndFp = userList.concat(fpList);

  yield put({
    type: ACTION_SET_USER_LIST,
    value: usersAndFp.map((item) => {
      return {
        id: item.advisorId,
        clientId: item.clientId,
        userId: item.userId,
        firstName: item.firstName,
        lastName: item.lastName,
        email: item.email,
        phone: item.phones,
        role: item.role.toUpperCase(),
        createDate: item.createDate,
        firmName: item.firmName,
        isLocked: item.isLocked,
        financialPros: [],
      };
    }),
  });
}




export function* carrierSagas() {
  yield takeLatest(SAGA_LOGIN, doLogin);
  yield takeLatest(SAGA_CREATE_USER, doCreateUser);
  yield takeLatest(SAGA_EDIT_USER, doEditUser);
  yield takeLatest(SAGA_FORGOT_PASSWORD, sendEmailForgotPassword);
  yield takeLatest(SAGA_GET_PLANINPUT, getPlanInput)
  yield takeLatest(SAGA_RELOAD_USER_LIST, reloadUserList);
  yield takeLatest(SAGA_GET_PLAN_CASH_FLOW, getPlanCashFlow);
  yield takeLatest(SAGA_GET_FUTURE_CASH_FLOW, getFuturePlanCashFlow);
}
